import { all } from "redux-saga/effects"
import auth from "../components/auth/authSaga"

/* main saga event loop */
export default function* appSaga() {
  yield all([auth()])
}
